var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 0C1.02931 0 0 1.08077 0 2.4V15.6C0 16.9192 1.02931 18 2.28571 18H21.7143C22.9707 18 24 16.9192 24 15.6V2.4C24 1.08077 22.9707 0 21.7143 0H2.28571ZM2.28571 1.2H21.7143C21.8218 1.2 21.92 1.21929 22.0179 1.24688L12.7857 11.025C12.3362 11.5019 11.6451 11.5019 11.1964 11.025L1.99107 1.2375C2.08565 1.21188 2.18223 1.2 2.28571 1.2ZM1.1875 2.1L7.99107 9.32811L1.19643 15.9469C1.16547 15.8362 1.14286 15.7229 1.14286 15.6V2.4C1.14286 2.29427 1.16434 2.19692 1.1875 2.1ZM22.8125 2.1C22.8356 2.19692 22.8571 2.29427 22.8571 2.4V15.6C22.8571 15.7229 22.8345 15.8362 22.8036 15.9469L16.0089 9.31875L22.8125 2.1ZM15.1964 10.1719L21.9643 16.7625C21.883 16.7811 21.8017 16.8 21.7143 16.8H2.28571C2.19826 16.8 2.11697 16.7811 2.03571 16.7625L8.79464 10.1813L10.3839 11.8688C11.2662 12.8066 12.7156 12.8053 13.5982 11.8688L15.1964 10.1719Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9ad5b7d20cc973f0e418be2c9a42b940.svg";
export { ForwardRef as ReactComponent };